<template>
  <div v-if="pickings && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="pickings"
    />
  </div>
</template>
<script>
import Waves from "@/api/waves";
import i18n from "@/i18n";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import { mapState } from "vuex";

export default {
  components: {
    MutiplePiecesPrint,
  },

  computed: {
    ...mapState(["accountUser"]),
  },

  data: () => ({
    formater: null,
    pickings: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("wavePicking").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;
          Waves.batchPickingPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.pickings = response.data.waves;
                if (this.pickings) {
                  this.pickings = this.pickings.map((picking) => {
                    let details = [];
                    picking.pick_details.forEach((detail) => {
                      if (detail.pick_details.length) {
                        detail.pick_details.forEach((d) => {
                          details.push(
                            Object.assign({}, d, {
                              material_bar_code: detail.material_bar_code,
                              category_name: detail.category_name,
                              standard_name: detail.standard_name,
                              material_name: detail.material_name,
                              storage_conditions: detail.storage_conditions,
                            })
                          );
                        });
                      } else {
                        details.push({
                          material_bar_code: detail.material_bar_code,
                          category_name: detail.category_name,
                          standard_name: detail.standard_name,
                          material_name: detail.material_name,
                          storage_conditions: detail.storage_conditions,
                          pick_stock_num: i18n.t("Wave.actions.outStock"),
                        });
                      }
                    });
                    picking = Object.assign({}, picking, {
                      pick_details: details,
                    });
                    return picking
                  })
                }
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>